// extracted by mini-css-extract-plugin
module.exports = {"ArticleSide":"ArticleSide_ArticleSide_Cfyhx","ArticleSideBox":"ArticleSide_ArticleSideBox_3Cp_c"};